import moment from 'moment'

import {
  hasAloAccessMembership,
  hasPremiumAccessMembership,
  isAloAccessType
} from './constants'

export const showLabel = (membershipTier, availabilityGating) => {
  if (hasPremiumAccessMembership(membershipTier)) return false
  if (
    hasAloAccessMembership(membershipTier) &&
    isAloAccessType(availabilityGating)
  )
    return false
  return true
}

export const getLocalDate = (d) => {
  let date = new Date(d)
  if (moment(date).isValid()) {
    return moment(date).local().format('MM/DD/YYYY')
  }

  date = String(d).replace(/-/g, '/')
  if (moment(date).isValid()) {
    return moment(date).local().format('MM/DD/YYYY')
  }

  return String(d)
}
